import React, { useContext, useRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ChangeResumeOrder from "../../hooks/editor/changeResumeOrder";
import { jsonEditorContext } from "../../Context/jsonEditorContext";
import { ResumeUpdateContext } from "../../Context/resumeUpdateContext";
import { userTypeContext } from "../../Context/FreeOrProContext";
import { useIsOverflow } from "./useIsOverflow";
import PreviewResume from "../../Components/Modals/PreviewResumeModal/PreviewResumeModal";

// import { useOutsideClickTempBody } from "../../Utils/UseOutsideClick";
import OutsideClickHandler from "react-outside-click-handler";
import { Header1 } from "./SeparateHeaders/Header1";
import { Header2 } from "./SeparateHeaders/Header2";
import parse from "html-react-parser";
import ContentEditable from "../../Components/ContentEditable/ContentEditable";
import SectionContainer from "./SectionContainer";
import { FontIncrease } from "../../Utils/FontIncrease";
import { useTranslation } from "react-i18next";
import Profile from "../Components/Profile/Profile";
import NonPremiumBadge from "../../Components/NonPremiumBadge/NonPremiumBadge";
import { pageMargins, fontVariations } from "../../TemplateConfig";
import tinycolor from "tinycolor2";
// import LoadCSSFromDB from "./LoadScssFromDb";
import "./TemplateLoader.scss";
import "../styles/01.scss";
import "../styles/02.scss";
import "../styles/03.scss";
import "../styles/04.scss";
import "../styles/05.scss";
import "../styles/06.scss";
import "../styles/07.scss";
import "../styles/08.scss";
import "../styles/09.scss";
import "../styles/10.scss";
import "../styles/11.scss";
import "../styles/12.scss";
import "../styles/13.scss";
import "../styles/14.scss";
import "../styles/15.scss";
import "../styles/16.scss";
import "../styles/17.scss";
import "../styles/19.scss";
import "../styles/20.scss";
import "../styles/51.scss";
import "../styles/52.scss";
import "../styles/53.scss";
import "../styles/54.scss";
import "../styles/55.scss";
import "../styles/56.scss";
import "../styles/57.scss";
import "../styles/58.scss";
import "../styles/59.scss";
import "../styles/60.scss";

function TemplateLoader(props) {
  const [t, i18n] = useTranslation("common");
  const pathname = window.location.pathname;

  const [isOverflow, setIsOverflow] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const ref = React.useRef();
  const IsOverflowData = useIsOverflow(ref, (isOverflowFromCallback) => {});

  const [pageArray, setPageArray] = useState("");
  const [showPage, setShowPage] = useState(false);
  const layoutData = useSelector((state) => state.layout);

  const { resume } = useSelector((state) => state.resumeGetById);
  const { json, isJson, isSample, setIsSample } = useContext(jsonEditorContext);
  const { userType, resumeCount } = useContext(userTypeContext);
  const [activePage, setActivePage] = useState(0);
  const settings = isJson
    ? json && json.editorSettings
    : props && props.resumeFields && props.resumeFields.editorSettings;

  const {
    sectionFocusData,
    setSectionFocusData,
    // visualEditorFocus,
    // setVisualEditorFocus,
  } = useContext(ResumeUpdateContext);

  const [templateId, setTemplateId] = useState("");

  const [layoutHeight, setLayoutHeight] = useState({
    0: [],
    1: [],
  });

  const [newSectionFocus, setNewSectionFocus] = useState(false);
  const [newItemFocus, setNewItemFocus] = useState(false);
  const [currentStateFocus, setCurrentStateFocus] = useState(false);

  const handlePreview = (event) => {
    event.stopPropagation();
    setShowPreview(true);
  };
  const hidePreview = () => {
    setShowPreview(false);
    setIsSample(false);
  };
  useEffect(() => {
    if (!props.visualEditorFocus) {
      setNewSectionFocus(false);
      setCurrentStateFocus(false);
      setNewItemFocus(false);
    }
  }, [props.visualEditorFocus]);

  useEffect(() => {
    if (
      props &&
      !props.previewModal &&
      !props.sample &&
      !props.preview &&
      pathname &&
      pathname.includes("resume")
    ) {
      setNewSectionFocus("summary");
      setCurrentStateFocus("section");
      setNewItemFocus(false);
      props.setVisualEditorFocus(true);
    }
  }, []);

  const changeFocusStyle = (sectionId, item, action) => {
    if (action == "section") {
      setNewSectionFocus(sectionId);
      setCurrentStateFocus("section");
      setNewItemFocus(false);
      props.setVisualEditorFocus(true);
    } else {
      setNewSectionFocus(sectionId);
      setCurrentStateFocus("item");
      setNewItemFocus(item);
      props.setVisualEditorFocus(true);
    }
  };

  const updateHeight = (layoutItem, position) => {
    setLayoutHeight((prevState) => {
      return {
        ...prevState,
        [position]: [...prevState[position], layoutItem],
      };
    });
  };

  //   useEffect(() =>{
  //   },[layoutHeight])

  //   const BreaksChange = () => {
  //     const { heights, pageBreak } = layoutHeight;
  //     const breaks = [];
  //     let runningHeights = [];

  //     let runningHeight = 0;

  //     heights.forEach((height, index) => {
  //       if (index === 0) {
  //         runningHeight = height;
  //         runningHeights.push(runningHeight);
  //         if (runningHeight >= pageBreak) {
  //           breaks.push(true);
  //         } else {
  //           breaks.push(false);
  //         }
  //       } else if (index > 0) {
  //         if (runningHeights[index - 1] < pageBreak) {
  //           runningHeight = runningHeights[index - 1] + height;
  //           runningHeights.push(runningHeight);

  //           if (runningHeight >= pageBreak) {
  //             breaks.push(true);
  //           } else {
  //             breaks.push(false);
  //           }
  //         } else {
  //           runningHeight = height;
  //           runningHeights.push(runningHeight);
  //           if (runningHeight >= pageBreak) {
  //             breaks.push(true);
  //           } else {
  //             breaks.push(false);
  //           }
  //         }
  //       }
  //     });
  //     setLayoutHeight((prevState) => {
  //       return {
  //         ...prevState,
  //         breaks: breaks,
  //       };
  //     });
  //   };

  useEffect(() => {
    if (sectionFocusData && sectionFocusData != "") {
      changeFocusStyle(sectionFocusData, false, "section");
    }
  }, [sectionFocusData]);

  let headerHtml;

  if (settings && settings.separateHeaderType == "Header1") {
    headerHtml = Header1;
  } else if (settings && settings.separateHeaderType == "Header2") {
    headerHtml = Header2;
  } else {
    headerHtml = Header1;
  }

  useEffect(() => {
    if (pathname?.includes("previewimageGenerate")) {
      setTemplateId(resume && resume.template_id);
    } else if (pathname?.includes("reviewimagegenerate")) {
      setTemplateId(resume && resume.template_id);
    } else if (isJson || isSample) {
      if (json && json.template_id) {
        setTemplateId(json.template_id);
      }
    } else {
      setTemplateId(resume && resume.template_id);
    }
  }, [isSample, resume, json, isJson]);
  const customStyle = isJson
    ? json && json.customization
    : props && props.resumeFields && props.resumeFields.customization;

  const componentArray =
    props && props.resumeFields && props.resumeFields.sectionPosition;
  const layoutArray = isJson ? json && json.layout : layoutData && layoutData;
  useEffect(() => {
    const layoutArray = isJson ? json && json.layout : layoutData && layoutData;
    if (layoutArray && layoutArray[0].length > 0) {
      let lsmax = layoutArray[0];
      let rsmax = layoutArray[1];
      let lsPage =
        lsmax[lsmax.length - 1] && lsmax[lsmax.length - 1]["page"]
          ? lsmax[lsmax.length - 1]["page"]
          : 0;
      let rsPage =
        rsmax[rsmax.length - 1] && rsmax[rsmax.length - 1]["page"]
          ? rsmax[rsmax.length - 1]["page"]
          : 0;

      let max_page = 0;
      if (lsPage >= rsPage) {
        max_page = lsPage;
      } else {
        max_page = rsPage;
      }

      let pageArray = [];
      for (var i = 0; i <= max_page; i++) {
        pageArray.push(i);
      }
      if (isSample) {
        setPageArray([0]);
      } else {
        setPageArray(pageArray);
      }
    }
  }, [layoutData, layoutArray]);

  useEffect(() => {
    if (pathname && pathname.includes("resumes")) {
      setShowPage(true);
    } else if (pathname && pathname.includes("qr")) {
      setShowPage(true);
    } else if (pathname && pathname.includes("create")) {
      setShowPage(true);
    }
  }, [pathname]);

  const dataCustomize = isJson
    ? json && json.customization && json.customization
    : props &&
      props.resumeFields &&
      props.resumeFields.customization &&
      props.resumeFields.customization;

  // For PreviewGeneratePage
  const multiColorOptions =
    dataCustomize &&
    dataCustomize.fonts &&
    dataCustomize.fonts.multi_color_option;

  let primaryColor_imageGenerate = "#3AB0FF";
  let secondaryColor_primaryColor_imageGenerate = "#FFB562";
  if (multiColorOptions) {
    const randomIndex = Math.floor(Math.random() * multiColorOptions.length);
    const randomElement = multiColorOptions[randomIndex];

    primaryColor_imageGenerate = randomElement?.primary_color;
    secondaryColor_primaryColor_imageGenerate = randomElement?.secondary_color;
  }

  const {
    fontSize,
    titleFont,
    bodyFont,
    primaryColor,
    secondaryColor,
    descriptionColor,
    sectionTitleColor,
    bgColor,
    linkColor,
    titleBgColor,
    background,
    PageMargin,
    SectionMargin,
    bg_color_options,
  } = dataCustomize && dataCustomize ? dataCustomize : "";
  const selectedBgColor = bgColor && bgColor;

  const styles = {
    primaryColor:
      pathname && pathname.includes("previewimageGenerate")
        ? primaryColor_imageGenerate
        : primaryColor,
    secondaryColor:
      pathname && pathname.includes("previewimageGenerate")
        ? secondaryColor_primaryColor_imageGenerate
        : secondaryColor,
    sectionTitleColor: sectionTitleColor,
    bgColor: bgColor,
    linkColor: linkColor,
    titleFont: titleFont,
    bodyFont: bodyFont,
    descriptionColor: descriptionColor,
    titleBgColor: titleBgColor,
    background: background,
    selectedFont: fontVariations[fontSize - 1],
    selectedBgColor: selectedBgColor,
    isMandatoryDescriptionColor: false,
  };

  const COMPONENTS = {
    education: require("../Components/Education/Education"),
    interests: require("../Components/Interests/Interests"),
    strengths: require("../Components/Strengths/Strengths"),
    languages: require("../Components/Languages/Languages"),
    profile: require("../Components/Profile/Profile"),
    skills: require("../Components/Skills/Skills"),
    summary: require("../Components/Summary/Summary"),
    customText: require("../Components/CustomText/CustomText"),
    experience: require("../Components/WorkExperience/WorkExperience"),
    customDate: require("../Components/CustomDate/CustomDate"),
    achievements: require("../Components/Achievements/Achievements"),
    projects: require("../Components/CommonDateComponents/Common"),
    volunteering: require("../Components/CommonDateComponents/Common"),
    onlinePresence: require("../Components/CommonTextComponents/Common"),
    certifications: require("../Components/CommonDateComponents/Common"),
    references: require("../Components/CommonTextComponents/Common"),
    publications: require("../Components/CommonDateComponents/Common"),
    books: require("../Components/CommonTextComponents/Common"),
    additionalExperience: require("../Components/CommonDateComponents/Common"),
    additionalSkills: require("../Components/CommonTextComponents/Common"),
    courses: require("../Components/CommonTextComponents/Common"),
    industryExpertise: require("../Components/CommonTextComponents/Common"),
  };

  const ProfileTitle = () => {
    return (
      props &&
      props.resumeFields &&
      props.resumeFields["profile"] &&
      props.resumeFields["profile"].data &&
      props.resumeFields["profile"].data[0] && (
        <ContentEditable
          sectionId={"profile"}
          name="name"
          tagType="div"
          className="resume-title-name"
          index={0}
          value={props.resumeFields["profile"].data[0].name}
          placeholder="Your Name"
          onChange={props.resumeHandler}
          onBlur={props.resumeUpdate}
          style={{
            fontFamily: styles.titleFont,
            color: styles.primaryColor,
            fontSize: FontIncrease(styles && styles.titleFontSize, 10),
            fontWeight: styles.bold,
          }}
        />
      )
    );
  };

  const ProfileJobTitle = () => {
    return (
      <>
        {props.resumeFields &&
          props.resumeFields["profile"] &&
          props.resumeFields["profile"].data &&
          props.resumeFields["profile"].data[0] &&
          props.resumeFields["profile"].data[0].showFields &&
          props.resumeFields["profile"].data[0].showFields.jobTitle &&
          props.resumeFields["profile"].data[0].showFields.jobTitle && (
            <ContentEditable
              sectionId={"profile"}
              name="jobTitle"
              index={0}
              tagType="p"
              className={"resume-job-name"}
              value={props.resumeFields["profile"].data[0].jobTitle}
              placeholder={t(`profile.jobTitle`)}
              onChange={props.resumeHandler}
              onBlur={props.resumeUpdate}
              style={{
                fontFamily: styles.bodyFont,
                fontSize: styles.bodyFontSize,
                fontSize: FontIncrease(styles && styles.titleFontSize, -3),
              }}
            />
          )}
      </>
    );
  };

  // const replace = (domNode) => {
  //   if (domNode.attribs && domNode.attribs.class === "resume-title-name") {
  //     return ProfileTitle(props.resumeHandler, props.resumeUpdate);
  //   } else if (
  //     domNode.attribs &&
  //     domNode.attribs.class === "resume-job-title"
  //   ) {
  //     return ProfileJobTitle(props.resumeHandler, props.resumeUpdate);
  //   }
  // };

  const injectStyletag = () => {
    let height =
      resume && resume.isLetter ? "1216px !important" : "1328px !important";

    let injectcss = `
        @media print {
          height:  ${height}
        }`;

    return <>{injectcss}</>;
  };

  const handleShowSplitPage = (pageNumber) => {
    setActivePage(pageNumber);
  };

  const handleSidePreview = () => {
    if (props?.isSplit) {
      props.handleEditor();
    }
  };

  //For page color
  const parentRef = useRef(null);
  const childRef = useRef(null);
  const [totalHeight, setTotalHeight] = useState(0);
  useEffect(() => {
    const parentElement = document.querySelector(".resume-editor");
    const childElement = document.querySelector(".profile-section");

    if (parentElement && childElement) {
      const parentTop = parentElement.offsetTop;
      const childTop = childElement.offsetTop;
      const childHeight = childElement.offsetHeight;
      const distance = childTop + childHeight - parentTop;

      setTotalHeight(distance);
    }
  }, [props]);

  useEffect(() => {
    if (props) {
      setActivePage(0);
    }
  }, [props]);

  const [isProfileColor, setIsProfileColor] = useState("four");

  return (
    <>
      {/* <link
        rel="stylesheet"
        type="text/css"
        href={`./style/` + templateId + `.css`}
      /> */}
      {/* <LoadCSSFromDB /> */}
      <style type="text/css">{injectStyletag()}</style>
      <PreviewResume
        id={props.id}
        cover={props.cover}
        showPreview={showPreview}
        hidePreview={hidePreview}
        setIsSample={setIsSample}
      />
      <div className="split-preview-page-button-wrapper text-center">
        {props &&
          props.isSplit &&
          pageArray &&
          pageArray.map((data, pageIndex) => {
            return (
              <>
                <button
                  className="btn btn-success split-preview-page-button mr-2 mb-3"
                  onClick={() => handleShowSplitPage(pageIndex)}
                >
                  {pageIndex + 1}
                </button>
              </>
            );
          })}
      </div>
      {pageArray &&
        pageArray.map((data, pageIndex) => {
          return (
            <>
              {pageIndex &&
              pageIndex !== 0 &&
              props &&
              !props.isSplit &&
              showPage ? (
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    margin: "0 auto",
                    textAlign: "center",
                  }}
                >
                  <h4 className="resume-page-mark">
                    <span className="page-mark"> Page {pageIndex + 1}</span>
                  </h4>
                </div>
              ) : (
                ""
              )}
              {props.visualEditorFocus ? <div className="outerdiv"></div> : ""}
              {props && props.isSplit && activePage != pageIndex ? (
                // For Calculate height
                <>
                  <div className="basic-editor-div-hide">
                    <div
                      ref={ref}
                      className={`resume-editor page-${pageIndex} temp-${templateId}`}
                      id={`resume-editor-${pageIndex}`}
                      style={
                        isSample
                          ? {
                              minHeight:
                                resume && resume.isLetter ? "1320px" : "1328px",
                              backgroundColor: bgColor,

                              backgroundImage: `url(${
                                process.env.REACT_APP_TEMPLATE_BACKGROUND_PATH
                              }/${
                                customStyle &&
                                customStyle.background &&
                                customStyle.background.bgShow
                                  ? customStyle &&
                                    customStyle.background &&
                                    customStyle.background.bgImage
                                  : ""
                              })`,
                              padding: pageMargins[parseInt(PageMargin) - 1],
                            }
                          : {
                              backgroundColor:
                                customStyle &&
                                customStyle.colors &&
                                customStyle.colors.bgColor,
                              height:
                                resume && resume.isLetter ? "1216px" : "1328px",
                              backgroundImage: `url(${
                                process.env.REACT_APP_TEMPLATE_BACKGROUND_PATH
                              }/${
                                customStyle &&
                                customStyle.background &&
                                customStyle.background.bgShow
                                  ? customStyle &&
                                    customStyle.background &&
                                    customStyle.background.bgImage
                                  : ""
                              })`,
                              padding: pageMargins[parseInt(PageMargin) - 1],
                            }
                      }
                    >
                      {/* <div className="right_bg_color"></div> */}
                      {/* {settings &&
                        settings.isSeparateHeader &&
                        pageIndex == 0 &&
                        parse(headerHtml, { replace })} */}

                      {/* {customStyle &&
                        customStyle.isProfileLayoutDifferent &&
                        pageIndex == 0 && (
                          <OutsideClickHandler
                            onOutsideClick={(e, value) => {
                              const parentWithClass =
                                e.target.closest(".resume-editor");

                              if (parentWithClass == null) {
                                props.setVisualEditorFocus(false);
                                setNewSectionFocus(false);
                                setCurrentStateFocus(false);
                                setNewItemFocus(false);
                              } else {
                                // setOutSideClick(false);
                              }
                            }}
                          >
                            <SectionContainer
                              sectionId={"profile"}
                              extraProfileClassName={"profile-layout-different"}
                              index={0}
                              row={0}
                              position={0}
                              layout={"lsbar"}
                              pageIndex={0}
                              newItemFocus={newItemFocus}
                              newSectionFocus={newSectionFocus}
                              changeFocusStyle={changeFocusStyle}
                              currentStateFocus={currentStateFocus}
                              isHeader={true}
                              styles={styles}
                              settings={settings}
                              resumeFields={props.resumeFields["profile"]}
                              resumeAllFields={props.resumeFields}
                              resumeHandler={props.resumeHandler}
                              resumeUpdate={props.resumeUpdate}
                              handleEditorChange={props.handleEditorChange}
                              addResumeField={props.addResumeField}
                              showHideElements={props.showHideElements}
                              showHideBackground={props.showHideBackground}
                              setResumeFields={props.setResumeFields}
                              updateHeight={updateHeight}
                              visualEditorFocus={props.visualEditorFocus}
                              previewModal={props.previewModal}
                              handleSliderChange={props.handleSliderChange}
                              handleProfileImageChange={
                                props.handleProfileImageChange
                              }
                              PageMargin={PageMargin}
                              SectionMargin={SectionMargin}
                              skillsLevelHandler={props.skillsLevelHandler}
                              handleBorderChange={props.handleBorderChange}
                            >
                              <Profile
                                sectionId={"profile"}
                                layout={"lsbar"}
                                pageIndex={pageIndex}
                                newItemFocus={newItemFocus}
                                newSectionFocus={newSectionFocus}
                                changeFocusStyle={changeFocusStyle}
                                currentStateFocus={currentStateFocus}
                                response={props.resumeFields}
                                settings={settings}
                                styles={styles}
                                resumeFields={props.resumeFields["profile"]}
                                resumeAllFields={props.resumeFields}
                                resumeHandler={props.resumeHandler}
                                resumeUpdate={props.resumeUpdate}
                                handleEditorChange={props.handleEditorChange}
                                addResumeField={props.addResumeField}
                                showHideElements={props.showHideElements}
                                showHideBackground={props.showHideBackground}
                                setResumeFields={props.setResumeFields}
                                selectedBgColor={selectedBgColor}
                                customStyle={customStyle}
                                PageMargin={PageMargin}
                              />
                            </SectionContainer>
                          </OutsideClickHandler>
                        )} */}
                      <div
                        className={
                          customStyle && customStyle.resumeLayout == "double"
                            ? "d-flex justify-content-between resume-section-container first-template-check"
                            : "resume-section-container"
                        }
                        style={
                          customStyle && customStyle.resumeLayout == "double"
                            ? {
                                gridAutoColumns: ` ${
                                  customStyle.grid_width
                                    ? customStyle.grid_width -
                                      pageMargins[parseInt(PageMargin) - 1] -
                                      40
                                    : 372 -
                                      pageMargins[parseInt(PageMargin) - 1] -
                                      40
                                }px 1fr`,
                              }
                            : {}
                        }
                      >
                        {["lsbar", "rsbar"].map((position) => {
                          const arrayIndex = position == "lsbar" ? 0 : 1;

                          return (
                            <div
                              className={
                                customStyle &&
                                customStyle.resumeLayout == "double"
                                  ? `double-layout resume-page-wrapper ${position}`
                                  : `single-layout resume-page-wrapper ${position}`
                              }
                              style={{
                                width:
                                  position && position == "lsbar"
                                    ? customStyle && customStyle.lsbar_width
                                    : customStyle && customStyle.rsbar_width,
                              }}
                            >
                              {componentArray &&
                                componentArray[position] &&
                                componentArray[position].map(
                                  (res, index, row) => {
                                    let modifiedStyles = { ...styles };
                                    if (position == "rsbar" && bgColor == 1) {
                                      modifiedStyles.primaryColor = "#ffffff";
                                      modifiedStyles.secondaryColor = "#ffffff";
                                    } else {
                                      modifiedStyles.primaryColor =
                                        primaryColor;
                                      modifiedStyles.secondaryColor =
                                        secondaryColor;
                                    }
                                    if (
                                      customStyle &&
                                      customStyle.isProfileLayoutDifferent &&
                                      res == "profile"
                                    ) {
                                      return;
                                    }
                                    let Component = res.includes("customDate")
                                      ? COMPONENTS["customDate"].default
                                      : res.includes("customText")
                                      ? COMPONENTS["customText"].default
                                      : COMPONENTS[res].default;

                                    return (
                                      <>
                                        {layoutArray &&
                                          layoutArray[arrayIndex] &&
                                          layoutArray[arrayIndex]
                                            .filter(
                                              (x) =>
                                                x.section == res &&
                                                x.page == pageIndex
                                            )
                                            .map((response) => {
                                              if (response.itemIndexes) {
                                                let newCount =
                                                  response.itemIndexes.length;
                                                //response.itemIndexes.push(newCount)
                                              }
                                              return (
                                                <OutsideClickHandler
                                                  onOutsideClick={(
                                                    e,
                                                    value
                                                  ) => {
                                                    const parentWithClass =
                                                      e.target.closest(
                                                        ".resume-page-wrapper"
                                                      );
                                                    const anotherParentWithClass =
                                                      e.target.closest(
                                                        ".profile-layout-different"
                                                      );

                                                    if (
                                                      parentWithClass == null &&
                                                      anotherParentWithClass ==
                                                        null
                                                    ) {
                                                      props.setVisualEditorFocus(
                                                        false
                                                      );
                                                      setNewSectionFocus(false);
                                                      setCurrentStateFocus(
                                                        false
                                                      );
                                                      setNewItemFocus(false);
                                                    } else {
                                                      // setOutSideClick(false);
                                                    }
                                                  }}
                                                >
                                                  <SectionContainer
                                                    position={arrayIndex}
                                                    pos={position}
                                                    resumeFields={
                                                      props.resumeFields[res]
                                                    }
                                                    resumeAllFields={
                                                      props.resumeFields
                                                    }
                                                    resumeHandler={
                                                      props.resumeHandler
                                                    }
                                                    resumeTitleHandler={
                                                      props.resumeTitleHandler
                                                    }
                                                    resumeUpdate={
                                                      props.resumeUpdate
                                                    }
                                                    sectionTitleUpdate={
                                                      props.sectionTitleUpdate
                                                    }
                                                    handleEditorChange={
                                                      props.handleEditorChange
                                                    }
                                                    dateHandler={
                                                      props.dateHandler
                                                    }
                                                    languageHandler={
                                                      props.languageHandler
                                                    }
                                                    addResumeField={
                                                      props.addResumeField
                                                    }
                                                    showHideElements={
                                                      props.showHideElements
                                                    }
                                                    sectionMoveUp={
                                                      props.sectionMoveUp
                                                    }
                                                    sectionMoveDown={
                                                      props.sectionMoveDown
                                                    }
                                                    sectionItemMoveUp={
                                                      props.sectionItemMoveUp
                                                    }
                                                    sectionItemMoveDown={
                                                      props.sectionItemMoveDown
                                                    }
                                                    handleItemDelete={
                                                      props.handleItemDelete
                                                    }
                                                    deletePopupShow={
                                                      props.deletePopupShow
                                                    }
                                                    showHideBackground={
                                                      props.showHideBackground
                                                    }
                                                    contentAdder={
                                                      props.contentAdder
                                                    }
                                                    sectionId={res}
                                                    index={index}
                                                    row={row}
                                                    layout={position}
                                                    pageIndex={pageIndex}
                                                    newItemFocus={newItemFocus}
                                                    newSectionFocus={
                                                      newSectionFocus
                                                    }
                                                    changeFocusStyle={
                                                      changeFocusStyle
                                                    }
                                                    currentStateFocus={
                                                      currentStateFocus
                                                    }
                                                    styles={modifiedStyles}
                                                    settings={settings}
                                                    setResumeFields={
                                                      props.setResumeFields
                                                    }
                                                    updateHeight={updateHeight}
                                                    visualEditorFocus={
                                                      props.visualEditorFocus
                                                    }
                                                    previewModal={
                                                      props.previewModal
                                                    }
                                                    handleSliderChange={
                                                      props.handleSliderChange
                                                    }
                                                    handleProfileImageChange={
                                                      props.handleProfileImageChange
                                                    }
                                                    PageMargin={PageMargin}
                                                    SectionMargin={
                                                      SectionMargin
                                                    }
                                                    skillsLevelHandler={
                                                      props.skillsLevelHandler
                                                    }
                                                    handleBorderChange={
                                                      props.handleBorderChange
                                                    }
                                                    changeIconSettings={
                                                      props.changeIconSettings
                                                    }
                                                  >
                                                    <Component
                                                      resumeFields={
                                                        props.resumeFields[res]
                                                      }
                                                      resumeAllFields={
                                                        props.resumeFields
                                                      }
                                                      resumeHandler={
                                                        props.resumeHandler
                                                      }
                                                      resumeTitleHandler={
                                                        props.resumeTitleHandler
                                                      }
                                                      sectionTitleUpdate={
                                                        props.sectionTitleUpdate
                                                      }
                                                      handleEditorChange={
                                                        props.handleEditorChange
                                                      }
                                                      dateHandler={
                                                        props.dateHandler
                                                      }
                                                      languageHandler={
                                                        props.languageHandler
                                                      }
                                                      addResumeField={
                                                        props.addResumeField
                                                      }
                                                      showHideElements={
                                                        props.showHideElements
                                                      }
                                                      sectionMoveUp={
                                                        props.sectionMoveUp
                                                      }
                                                      sectionMoveDown={
                                                        props.sectionMoveDown
                                                      }
                                                      sectionItemMoveUp={
                                                        props.sectionItemMoveUp
                                                      }
                                                      sectionItemMoveDown={
                                                        props.sectionItemMoveDown
                                                      }
                                                      handleItemDelete={
                                                        props.handleItemDelete
                                                      }
                                                      deletePopupShow={
                                                        props.deletePopupShow
                                                      }
                                                      showHideBackground={
                                                        props.showHideBackground
                                                      }
                                                      contentAdder={
                                                        props.contentAdder
                                                      }
                                                      resumeUpdate={
                                                        props.resumeUpdate
                                                      }
                                                      sectionId={res}
                                                      layout={position}
                                                      pageIndex={pageIndex}
                                                      newItemFocus={
                                                        newItemFocus
                                                      }
                                                      newSectionFocus={
                                                        newSectionFocus
                                                      }
                                                      changeFocusStyle={
                                                        changeFocusStyle
                                                      }
                                                      currentStateFocus={
                                                        currentStateFocus
                                                      }
                                                      response={response}
                                                      styles={styles}
                                                      settings={settings}
                                                      setResumeFields={
                                                        props.setResumeFields
                                                      }
                                                      visualEditorFocus={
                                                        props.visualEditorFocus
                                                      }
                                                      previewModal={
                                                        props.previewModal
                                                      }
                                                      handleSliderChange={
                                                        props.handleSliderChange
                                                      }
                                                      handleProfileImageChange={
                                                        props.handleProfileImageChange
                                                      }
                                                      handleAchievementSvg={
                                                        props.handleAchievementSvg
                                                      }
                                                      handleItemIcon={
                                                        props.handleItemIcon
                                                      }
                                                      skillsLevelHandlerRcSlider={
                                                        props.skillsLevelHandlerRcSlider
                                                      }
                                                      handleLanguageSliderChange={
                                                        props.handleLanguageSliderChange
                                                      }
                                                    />
                                                  </SectionContainer>
                                                </OutsideClickHandler>
                                              );
                                            })}
                                      </>
                                    );
                                  }
                                )}
                            </div>
                          );
                        })}
                      </div>
                      {/* {userType &&
                userType == "free" &&
                !pathname.includes("preview") ? (
                  <NonPremiumBadge />
                ) : (
                  ""
                )} */}
                      {userType &&
                      userType == "free" &&
                      pathname.includes("preview1") ? (
                        <NonPremiumBadge
                          previewModal={props.previewModal}
                          pathname={pathname}
                        />
                      ) : userType &&
                        userType == "free" &&
                        !pathname.includes("preview") ? (
                        <NonPremiumBadge
                          previewModal={props.previewModal}
                          pathname={pathname}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </>
              ) : (
                // need to add cursor for side preview condition
                <div onClick={handleSidePreview}>
                  <div
                    ref={ref}
                    className={`resume-editor page-${pageIndex} temp-${templateId}`}
                    id={`resume-editor-${pageIndex}`}
                    style={
                      isSample
                        ? {
                            minHeight:
                              resume && resume.isLetter ? "1320px" : "1328px",
                            backgroundColor:
                              customStyle &&
                              customStyle.colors &&
                              customStyle.colors.bgColor,

                            backgroundImage: `url(${
                              process.env.REACT_APP_TEMPLATE_BACKGROUND_PATH
                            }/${
                              customStyle &&
                              customStyle.background &&
                              customStyle.background.bgShow
                                ? customStyle &&
                                  customStyle.background &&
                                  customStyle.background.bgImage
                                : ""
                            })`,
                            padding: pageMargins[parseInt(PageMargin) - 1],
                          }
                        : {
                            backgroundColor: selectedBgColor?.lsbar,
                            height:
                              resume && resume.isLetter ? "1216px" : "1328px",
                            backgroundImage: `url(${
                              process.env.REACT_APP_TEMPLATE_BACKGROUND_PATH
                            }/${
                              customStyle &&
                              customStyle.background &&
                              customStyle.background.bgShow
                                ? customStyle &&
                                  customStyle.background &&
                                  customStyle.background.bgImage
                                : ""
                            })`,
                            padding: pageMargins[parseInt(PageMargin) - 1],
                          }
                    }
                  >
                    {customStyle &&
                    customStyle.bgColor &&
                    customStyle.bgColor.bgFill &&
                    customStyle.bgColor.bgFill == "right" ? (
                      <>
                        <div
                          class="section"
                          style={{
                            width: customStyle.grid_width ? 372 : 320,
                            height:
                              resume && resume.isLetter ? "1216px" : "1328px",
                            backgroundColor:
                              customStyle &&
                              customStyle.bgColor &&
                              customStyle.bgColor.bgColor,
                            top: 0,
                            right: 0,
                          }}
                        ></div>
                      </>
                    ) : customStyle &&
                      customStyle.bgColor &&
                      customStyle.bgColor.bgFill &&
                      customStyle.bgColor.bgFill == "left" ? (
                      <>
                        {" "}
                        <div
                          class="section"
                          style={{
                            width: customStyle.grid_width ? 372 : 326,
                            height:
                              resume && resume.isLetter ? "1216px" : "1328px",
                            backgroundColor: customStyle?.bgColor?.bgColor,
                            top: 0,
                            left: 0,
                          }}
                        ></div>
                      </>
                    ) : customStyle &&
                      customStyle.bgColor &&
                      customStyle.bgColor.bgFill &&
                      customStyle.bgColor.bgFill == "top" ? (
                      <>
                        <div
                          class="section"
                          style={{
                            width: "100%",
                            height: totalHeight,
                            backgroundColor: customStyle?.bgColor?.bgColor,
                            top: 0,
                            left: 0,
                          }}
                        ></div>
                      </>
                    ) : (
                      <>
                        {" "}
                        <div
                          class="section"
                          style={{
                            width: "100%",
                            height:
                              resume && resume.isLetter ? "1216px" : "1328px",
                            backgroundColor: customStyle?.bgColor?.bgColor,
                            top: 0,
                            right: 0,
                          }}
                        ></div>
                      </>
                    )}
                    {settings &&
                    settings.isSinglePageBgcolor &&
                    pageIndex > 0 ? (
                      <>
                        <div
                          class="section"
                          style={{
                            width: `calc(100% - ${
                              customStyle && customStyle.grid_width
                                ? customStyle && customStyle.grid_width
                                : 260
                            }px)`,
                            height: totalHeight,
                            backgroundColor: "#ffffff",
                            top: 0,
                            left: 0,
                          }}
                        ></div>
                        <div
                          class="section"
                          style={{
                            width:
                              customStyle && customStyle.grid_width
                                ? customStyle.grid_width +
                                  parseInt(PageMargin) * 10 +
                                  40
                                : 260,
                            height: totalHeight,
                            backgroundColor: "#ffffff",
                            top: 0,
                            right: 0,
                          }}
                        ></div>
                        <div
                          class="section"
                          style={{
                            width: `calc(100% - ${
                              customStyle.grid_width
                                ? customStyle.grid_width
                                : 260
                            }px)`,
                            height: `calc(100% - ${totalHeight}px)`,
                            backgroundColor: "#ffffff",
                            top: totalHeight,
                            left: 0,
                          }}
                        ></div>
                        <div
                          class="section"
                          style={{
                            width: customStyle.grid_width
                              ? customStyle.grid_width +
                                parseInt(PageMargin) * 10 +
                                40
                              : 260,
                            height: `calc(100% - ${totalHeight}px)`,
                            backgroundColor: "#ffffff",
                            top: totalHeight,
                            right: 0,
                          }}
                        ></div>
                      </>
                    ) : (
                      <>
                        <div class="">
                          {isProfileColor == "single" ? (
                            <>
                              <div
                                class="section"
                                style={{
                                  width: "100%",
                                  height: totalHeight,
                                  backgroundColor: "#ff5733",
                                  top: 0,
                                  left: 0,
                                }}
                              ></div>
                            </>
                          ) : isProfileColor == "double" ? (
                            <>
                              <div
                                class="section"
                                style={{
                                  width: `calc(100% - ${
                                    customStyle.grid_width
                                      ? customStyle.grid_width
                                      : 260
                                  }px)`,
                                  height: totalHeight,
                                  backgroundColor: "#000",
                                  top: 0,
                                  left: 0,
                                }}
                              ></div>
                              <div
                                class="section"
                                style={{
                                  width: customStyle.grid_width
                                    ? customStyle.grid_width
                                    : 260,
                                  height: totalHeight,
                                  backgroundColor: "#701233",
                                  top: 0,
                                  right: 0,
                                }}
                              ></div>
                            </>
                          ) : isProfileColor == "four" ? (
                            <>
                              <div
                                class="section"
                                style={{
                                  width: `calc(100% - ${
                                    customStyle && customStyle.grid_width
                                      ? customStyle && customStyle.grid_width
                                      : 260
                                  }px)`,
                                  height: totalHeight,
                                  backgroundColor: selectedBgColor?.section1,
                                  top: 0,
                                  left: 0,
                                }}
                              ></div>
                              <div
                                class="section"
                                style={{
                                  width:
                                    customStyle && customStyle.grid_width
                                      ? customStyle.grid_width +
                                        parseInt(PageMargin) * 10 +
                                        40
                                      : 260,
                                  height: totalHeight,
                                  backgroundColor: selectedBgColor?.section2
                                    ? selectedBgColor?.section2
                                    : selectedBgColor?.section1,
                                  top: 0,
                                  right: 0,
                                }}
                              ></div>
                              <div
                                class="section"
                                style={{
                                  width: `calc(100% - ${
                                    customStyle && customStyle.grid_width
                                      ? customStyle.grid_width
                                      : 260
                                  }px)`,
                                  height: `calc(100% - ${totalHeight}px)`,
                                  backgroundColor: selectedBgColor?.section3
                                    ? selectedBgColor?.section3
                                    : selectedBgColor?.section1,
                                  top: totalHeight,
                                  left: 0,
                                }}
                              ></div>
                              <div
                                class="section"
                                style={{
                                  width:
                                    customStyle && customStyle.grid_width
                                      ? customStyle.grid_width +
                                        parseInt(PageMargin) * 10 +
                                        40
                                      : 260,
                                  height: `calc(100% - ${totalHeight}px)`,
                                  backgroundColor: selectedBgColor?.section4
                                    ? selectedBgColor?.section4
                                    : selectedBgColor?.section1,
                                  top: totalHeight,
                                  right: 0,
                                }}
                              ></div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </>
                    )}
                    <div
                      className="bg-image-wrapper"
                      style={{
                        backgroundImage: `url(${
                          process.env.REACT_APP_TEMPLATE_BACKGROUND_PATH
                        }/${
                          customStyle &&
                          customStyle.background &&
                          customStyle.background.bgShow
                            ? customStyle &&
                              customStyle.background &&
                              customStyle.background.bgImage
                            : ""
                        })`,
                      }}
                    ></div>
                    {/* <div
                      className="right_bg_color"
                      style={{
                        backgroundColor: selectedBgColor?.rsbar,
                      }}
                    ></div> */}
                    {props && props.isSplit && !props.pickTemplate && (
                      <>
                        <button
                          className="btn btn-success split-preview-preview-button"
                          onClick={(e) => handlePreview(e)}
                        >
                          Preview
                        </button>
                      </>
                    )}
                    {/* {settings &&
                      settings.isSeparateHeader &&
                      pageIndex == 0 &&
                      parse(headerHtml, { replace })} */}

                    {true && pageIndex == 0 && (
                      <OutsideClickHandler
                        onOutsideClick={(e, value) => {
                          const parentWithClass =
                            e.target.closest(".resume-editor");

                          if (parentWithClass == null) {
                            props.setVisualEditorFocus(false);
                            setNewSectionFocus(false);
                            setCurrentStateFocus(false);
                            setNewItemFocus(false);
                          } else {
                            // setOutSideClick(false);
                          }
                        }}
                      >
                        <SectionContainer
                          sectionId={"profile"}
                          extraProfileClassName={"profile-layout-different"}
                          index={0}
                          row={0}
                          position={0}
                          pos={"profile"}
                          layout={"lsbar"}
                          pageIndex={0}
                          newItemFocus={newItemFocus}
                          newSectionFocus={newSectionFocus}
                          changeFocusStyle={changeFocusStyle}
                          currentStateFocus={currentStateFocus}
                          isHeader={true}
                          styles={styles}
                          settings={settings}
                          resumeFields={props.resumeFields["profile"]}
                          resumeAllFields={props.resumeFields}
                          resumeHandler={props.resumeHandler}
                          resumeUpdate={props.resumeUpdate}
                          handleEditorChange={props.handleEditorChange}
                          addResumeField={props.addResumeField}
                          showHideElements={props.showHideElements}
                          showHideBackground={props.showHideBackground}
                          setResumeFields={props.setResumeFields}
                          updateHeight={updateHeight}
                          visualEditorFocus={props.visualEditorFocus}
                          previewModal={props.previewModal}
                          handleSliderChange={props.handleSliderChange}
                          handleProfileImageChange={
                            props.handleProfileImageChange
                          }
                          PageMargin={PageMargin}
                          SectionMargin={SectionMargin}
                          skillsLevelHandler={props.skillsLevelHandler}
                          handleBorderChange={props.handleBorderChange}
                          changeIconSettings={props.changeIconSettings}
                        >
                          <Profile
                            sectionId={"profile"}
                            layout={"lsbar"}
                            pageIndex={pageIndex}
                            newItemFocus={newItemFocus}
                            newSectionFocus={newSectionFocus}
                            changeFocusStyle={changeFocusStyle}
                            currentStateFocus={currentStateFocus}
                            response={props.resumeFields}
                            styles={styles}
                            settings={settings}
                            resumeFields={props.resumeFields["profile"]}
                            resumeAllFields={props.resumeFields}
                            resumeHandler={props.resumeHandler}
                            resumeUpdate={props.resumeUpdate}
                            handleEditorChange={props.handleEditorChange}
                            addResumeField={props.addResumeField}
                            showHideElements={props.showHideElements}
                            showHideBackground={props.showHideBackground}
                            setResumeFields={props.setResumeFields}
                            selectedBgColor={selectedBgColor}
                            customStyle={customStyle}
                            PageMargin={PageMargin}
                          />
                        </SectionContainer>
                      </OutsideClickHandler>
                    )}
                    {/* <Profile
                      sectionId={"profile"}
                      layout={"lsbar"}
                      pageIndex={pageIndex}
                      newItemFocus={newItemFocus}
                      newSectionFocus={newSectionFocus}
                      changeFocusStyle={changeFocusStyle}
                      currentStateFocus={currentStateFocus}
                      response={props.resumeFields}
                      styles={styles}
                      settings={settings}
                      resumeFields={props.resumeFields["profile"]}
                      resumeAllFields={props.resumeFields}
                      resumeHandler={props.resumeHandler}
                      resumeUpdate={props.resumeUpdate}
                      handleEditorChange={props.handleEditorChange}
                      addResumeField={props.addResumeField}
                      showHideElements={props.showHideElements}
                      showHideBackground={props.showHideBackground}
                      setResumeFields={props.setResumeFields}
                    /> */}
                    <div
                      className={
                        customStyle && customStyle.resumeLayout == "double"
                          ? "double_resume_column resume-section-container first-template-check"
                          : "single_resume_column resume-section-container"
                      }
                      style={
                        customStyle && customStyle.resumeLayout === "double"
                          ? {
                              gridAutoColumns: ` ${
                                customStyle.grid_width
                                  ? customStyle.grid_width -
                                    pageMargins[parseInt(PageMargin) - 1] -
                                    40
                                  : 372 -
                                    pageMargins[parseInt(PageMargin) - 1] -
                                    40
                              }px 1fr`,
                            }
                          : undefined // Set style to undefined when the condition is not met
                      }
                    >
                      {["lsbar", "rsbar"].map((position) => {
                        const arrayIndex = position == "lsbar" ? 0 : 1;

                        return (
                          <div
                            className={
                              customStyle &&
                              customStyle.resumeLayout == "double"
                                ? `double-layout resume-page-wrapper ${position}`
                                : `single-layout resume-page-wrapper ${position}`
                            }
                            style={{
                              width:
                                customStyle && customStyle.isGridSplit
                                  ? position && position === "lsbar"
                                    ? customStyle && customStyle.lsbar_width
                                    : customStyle && customStyle.rsbar_width
                                  : undefined, // Set width to undefined when isGridSplit is false
                            }}
                          >
                            {componentArray &&
                              componentArray[position] &&
                              componentArray[position].map(
                                (res, index, row) => {
                                  let modifiedStyles = { ...styles };
                                  if (
                                    bgColor &&
                                    bgColor.bgFill === "right" &&
                                    position == "rsbar"
                                  ) {
                                    modifiedStyles.iconColor =
                                      bgColor && bgColor.bgColor;
                                    modifiedStyles.primaryColor = tinycolor(
                                      bgColor && bgColor.bgColor
                                    ).isLight()
                                      ? "#000"
                                      : "#fff";
                                    modifiedStyles.secondaryColor = tinycolor(
                                      bgColor && bgColor.bgColor
                                    ).isLight()
                                      ? "#000"
                                      : "#fff";
                                    modifiedStyles.isMandatoryDescriptionColor = true;
                                    modifiedStyles.iconPrimaryColor =
                                      styles.secondaryColor;
                                    modifiedStyles.iconSecondaryColor = "white";
                                  } else if (
                                    bgColor &&
                                    bgColor.bgFill === "left" &&
                                    position == "lsbar"
                                  ) {
                                    modifiedStyles.iconColor =
                                      bgColor && bgColor.bgColor;
                                    modifiedStyles.primaryColor = tinycolor(
                                      bgColor && bgColor.bgColor
                                    ).isLight()
                                      ? "#000"
                                      : "#fff";
                                    modifiedStyles.secondaryColor = tinycolor(
                                      bgColor && bgColor.bgColor
                                    ).isLight()
                                      ? "#000"
                                      : "#fff";
                                    modifiedStyles.isMandatoryDescriptionColor = true;
                                    modifiedStyles.iconPrimaryColor =
                                      styles.secondaryColor;
                                    modifiedStyles.iconSecondaryColor = "white";
                                  } else {
                                    modifiedStyles.iconColor = "#ffffff";
                                    modifiedStyles.primaryColor = primaryColor;
                                    modifiedStyles.secondaryColor =
                                      secondaryColor;
                                    modifiedStyles.isMandatoryDescriptionColor = false;
                                    modifiedStyles.iconPrimaryColor = "white";
                                    modifiedStyles.iconSecondaryColor =
                                      styles.secondaryColor;
                                  }
                                  if (res == "profile") {
                                    return;
                                  }
                                  let Component = res.includes("customDate")
                                    ? COMPONENTS["customDate"].default
                                    : res.includes("customText")
                                    ? COMPONENTS["customText"].default
                                    : COMPONENTS[res].default;

                                  return (
                                    <>
                                      {layoutArray &&
                                        layoutArray[arrayIndex] &&
                                        layoutArray[arrayIndex]
                                          .filter(
                                            (x) =>
                                              x.section == res &&
                                              x.page == pageIndex
                                          )
                                          .map((response) => {
                                            if (response.itemIndexes) {
                                              let newCount =
                                                response.itemIndexes.length;
                                              //response.itemIndexes.push(newCount)
                                            }
                                            return (
                                              <OutsideClickHandler
                                                onOutsideClick={(e, value) => {
                                                  const parentWithClass =
                                                    e.target.closest(
                                                      ".resume-page-wrapper"
                                                    );
                                                  const anotherParentWithClass =
                                                    e.target.closest(
                                                      ".profile-layout-different"
                                                    );

                                                  if (
                                                    parentWithClass == null &&
                                                    anotherParentWithClass ==
                                                      null
                                                  ) {
                                                    props.setVisualEditorFocus(
                                                      false
                                                    );
                                                    setNewSectionFocus(false);
                                                    setCurrentStateFocus(false);
                                                    setNewItemFocus(false);
                                                  } else {
                                                    // setOutSideClick(false);
                                                  }
                                                }}
                                              >
                                                <SectionContainer
                                                  position={arrayIndex}
                                                  pos={position}
                                                  resumeFields={
                                                    props.resumeFields[res]
                                                  }
                                                  resumeAllFields={
                                                    props.resumeFields
                                                  }
                                                  resumeHandler={
                                                    props.resumeHandler
                                                  }
                                                  resumeTitleHandler={
                                                    props.resumeTitleHandler
                                                  }
                                                  resumeUpdate={
                                                    props.resumeUpdate
                                                  }
                                                  sectionTitleUpdate={
                                                    props.sectionTitleUpdate
                                                  }
                                                  handleEditorChange={
                                                    props.handleEditorChange
                                                  }
                                                  dateHandler={
                                                    props.dateHandler
                                                  }
                                                  languageHandler={
                                                    props.languageHandler
                                                  }
                                                  addResumeField={
                                                    props.addResumeField
                                                  }
                                                  showHideElements={
                                                    props.showHideElements
                                                  }
                                                  sectionMoveUp={
                                                    props.sectionMoveUp
                                                  }
                                                  sectionMoveDown={
                                                    props.sectionMoveDown
                                                  }
                                                  sectionItemMoveUp={
                                                    props.sectionItemMoveUp
                                                  }
                                                  sectionItemMoveDown={
                                                    props.sectionItemMoveDown
                                                  }
                                                  handleItemDelete={
                                                    props.handleItemDelete
                                                  }
                                                  deletePopupShow={
                                                    props.deletePopupShow
                                                  }
                                                  showHideBackground={
                                                    props.showHideBackground
                                                  }
                                                  contentAdder={
                                                    props.contentAdder
                                                  }
                                                  sectionId={res}
                                                  index={index}
                                                  row={row}
                                                  layout={position}
                                                  pageIndex={pageIndex}
                                                  newItemFocus={newItemFocus}
                                                  newSectionFocus={
                                                    newSectionFocus
                                                  }
                                                  changeFocusStyle={
                                                    changeFocusStyle
                                                  }
                                                  currentStateFocus={
                                                    currentStateFocus
                                                  }
                                                  styles={modifiedStyles}
                                                  settings={settings}
                                                  setResumeFields={
                                                    props.setResumeFields
                                                  }
                                                  updateHeight={updateHeight}
                                                  visualEditorFocus={
                                                    props.visualEditorFocus
                                                  }
                                                  previewModal={
                                                    props.previewModal
                                                  }
                                                  handleSliderChange={
                                                    props.handleSliderChange
                                                  }
                                                  handleProfileImageChange={
                                                    props.handleProfileImageChange
                                                  }
                                                  PageMargin={PageMargin}
                                                  SectionMargin={SectionMargin}
                                                  skillsLevelHandler={
                                                    props.skillsLevelHandler
                                                  }
                                                  handleBorderChange={
                                                    props.handleBorderChange
                                                  }
                                                  changeIconSettings={
                                                    props.changeIconSettings
                                                  }
                                                >
                                                  <Component
                                                    resumeFields={
                                                      props.resumeFields[res]
                                                    }
                                                    resumeAllFields={
                                                      props.resumeFields
                                                    }
                                                    resumeHandler={
                                                      props.resumeHandler
                                                    }
                                                    resumeTitleHandler={
                                                      props.resumeTitleHandler
                                                    }
                                                    sectionTitleUpdate={
                                                      props.sectionTitleUpdate
                                                    }
                                                    handleEditorChange={
                                                      props.handleEditorChange
                                                    }
                                                    dateHandler={
                                                      props.dateHandler
                                                    }
                                                    languageHandler={
                                                      props.languageHandler
                                                    }
                                                    addResumeField={
                                                      props.addResumeField
                                                    }
                                                    showHideElements={
                                                      props.showHideElements
                                                    }
                                                    sectionMoveUp={
                                                      props.sectionMoveUp
                                                    }
                                                    sectionMoveDown={
                                                      props.sectionMoveDown
                                                    }
                                                    sectionItemMoveUp={
                                                      props.sectionItemMoveUp
                                                    }
                                                    sectionItemMoveDown={
                                                      props.sectionItemMoveDown
                                                    }
                                                    handleItemDelete={
                                                      props.handleItemDelete
                                                    }
                                                    deletePopupShow={
                                                      props.deletePopupShow
                                                    }
                                                    showHideBackground={
                                                      props.showHideBackground
                                                    }
                                                    contentAdder={
                                                      props.contentAdder
                                                    }
                                                    resumeUpdate={
                                                      props.resumeUpdate
                                                    }
                                                    sectionId={res}
                                                    layout={position}
                                                    pageIndex={pageIndex}
                                                    newItemFocus={newItemFocus}
                                                    newSectionFocus={
                                                      newSectionFocus
                                                    }
                                                    changeFocusStyle={
                                                      changeFocusStyle
                                                    }
                                                    currentStateFocus={
                                                      currentStateFocus
                                                    }
                                                    response={response}
                                                    styles={styles}
                                                    settings={settings}
                                                    setResumeFields={
                                                      props.setResumeFields
                                                    }
                                                    visualEditorFocus={
                                                      props.visualEditorFocus
                                                    }
                                                    previewModal={
                                                      props.previewModal
                                                    }
                                                    handleSliderChange={
                                                      props.handleSliderChange
                                                    }
                                                    handleProfileImageChange={
                                                      props.handleProfileImageChange
                                                    }
                                                    handleAchievementSvg={
                                                      props.handleAchievementSvg
                                                    }
                                                    handleItemIcon={
                                                      props.handleItemIcon
                                                    }
                                                    skillsLevelHandlerRcSlider={
                                                      props.skillsLevelHandlerRcSlider
                                                    }
                                                    handleLanguageSliderChange={
                                                      props.handleLanguageSliderChange
                                                    }
                                                  />
                                                </SectionContainer>
                                              </OutsideClickHandler>
                                            );
                                          })}
                                    </>
                                  );
                                }
                              )}
                          </div>
                        );
                      })}
                    </div>
                    {/* {userType &&
                userType == "free" &&
                !pathname.includes("preview") ? (
                  <NonPremiumBadge />
                ) : (
                  ""
                )} */}
                    {userType &&
                    userType == "free" &&
                    pathname.includes("preview1") ? (
                      <NonPremiumBadge
                        previewModal={props.previewModal}
                        pathname={pathname}
                      />
                    ) : userType &&
                      userType == "free" &&
                      !pathname.includes("preview") ? (
                      <NonPremiumBadge
                        previewModal={props.previewModal}
                        pathname={pathname}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              )}
            </>
          );
        })}
    </>
  );
}

export default TemplateLoader;
